import { render } from "./MarketPlaceView.vue?vue&type=template&id=3a2f2396&scoped=true"
import script from "./MarketPlaceView.vue?vue&type=script&lang=js"
export * from "./MarketPlaceView.vue?vue&type=script&lang=js"

import "./MarketPlaceView.vue?vue&type=style&index=0&id=3a2f2396&scoped=true&lang=css"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a2f2396"]])

export default __exports__